<header [style.background-color]="siteData()?.knowledgeBase?.headerColor ?? '#ffffff'">

</header>
